// extracted by mini-css-extract-plugin
export var dividerLine = "_5i-0";
export var errorBackground = "_5i-1";